<div
  class="mail-form"
  [class]="formData.styleClasses"
  [ngClass]="{ container: isNewsletterForm || isContactMeForm }"
  *ngIf="formFields$ | async as formFields"
>
  <form [formGroup]="group" (ngSubmit)="onFormSubmit()">
    <ng-container *ngIf="isNewsletterForm || isContactMeForm; else defaultTemplate">
      <ng-container *ngFor="let field of formFields; let i = index">
        <p class="lead-signup-label" *ngIf="field.type === 'LABEL' && i === 0" [innerHTML]="field.label"></p>
        <p class="sub-signup-label" *ngIf="field.type === 'LABEL' && i === 1" [innerHTML]="field.label"></p>
        <div class="email-container" *ngIf="field.type === 'EMAIL'" [ngClass]="{ success: formSuccess }">
          <py-reactive-form-input-field
            [group]="group"
            [fieldName]="field.name"
            [showSuccessState]="true"
            [inputType]="field.type"
            [placeholder]="'mailForm.email_placeholder' | cxTranslate"
            [ariaLabel]="field.label ? field.label : ('mailForm.email_placeholder' | cxTranslate)"
          ></py-reactive-form-input-field>
          <py-action-button
            type="submit"
            [buttonLabel]="this.formData.labelSubmit"
            [successText]="this.formData.textSuccess"
            [success]="formSuccess"
            [loading]="isLoading"
            [buttonClass]="'btn w-100 h-100 ' + buttonClass"
          >
          </py-action-button>
        </div>
        <p class="bottom-signup-label" *ngIf="field.type === 'LABEL' && i === 3" [innerHTML]="field.label"></p>
      </ng-container>
    </ng-container>

    <ng-template #defaultTemplate>
      <div class="form-inner" [ngClass]="{ expand: isFormExpanded }">
        <ng-container *ngFor="let field of formFields">
          <ng-container [ngSwitch]="field.type">
            <ng-container *ngIf="field.name?.toLowerCase() === 'participant'; else defaultField">
              <hr />
              <form class="participants" formArrayName="participants" onsubmit="return false;">
                <a class="add-participants" (click)="addParticipant()">
                  <i nz-icon nzType="plus-circle" nzTheme="fill" class="mr-2"></i>
                  {{ 'mailForm.education.addParticipants_action' | cxTranslate }}
                </a>
                <label *ngFor="let participant of participants.controls; let i = index">
                  <div class="row no-gutters">
                    <div class="col-10">
                      <py-reactive-form-input-field
                        fieldName="name"
                        [label]="'mailForm.education.participantName_heading' | cxTranslate"
                        showSuccessState="true"
                        [group]="participants.controls[i]"
                      ></py-reactive-form-input-field>
                    </div>
                    <a class="align-self-center col-2 remove-participants" (click)="removeParticipant(i)">
                      <i nz-icon nzType="close-circle" nzTheme="fill"></i>
                    </a>
                  </div>
                </label>
              </form>
              <hr />
            </ng-container>
            <ng-template #defaultField>
              <ng-container *ngSwitchCase="'LABEL'">
                <p class="mail-form-label">{{ field.label }}</p>
              </ng-container>
              <ng-container *ngSwitchCase="'LONGTEXT'">
                <py-reactive-form-textarea [group]="group" [fieldName]="field.name"></py-reactive-form-textarea>
              </ng-container>
              <ng-container *ngSwitchCase="'SELECT'">
                <!-- Not implemented -->
              </ng-container>
              <ng-container *ngSwitchCase="'FILE'">
                <py-file-upload class="d-block mt-5" [multiple]="true" (emitFiles)="files = $event"></py-file-upload>
              </ng-container>
              <ng-container *ngSwitchCase="'CHECKBOX'">
                <div class="form-group py-5">
                  <py-reactive-form-checkbox
                    [group]="group"
                    [rounded]="true"
                    [fieldName]="field.name"
                    [rightLabel]="field.label"
                  ></py-reactive-form-checkbox>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'RADIOBUTTON'">
                <!-- Not implemented -->
              </ng-container>
              <!-- Default: 'EMAIL' | 'TEXT' | 'NUMBER' -->
              <ng-container *ngSwitchDefault>
                <py-reactive-form-input-field
                  [group]="group"
                  [fieldName]="field.name"
                  [label]="field.label"
                  [showSuccessState]="true"
                  [inputType]="field.type"
                ></py-reactive-form-input-field>
              </ng-container>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
      <py-action-button
        type="submit"
        [buttonLabel]="formData.labelSubmit"
        class="w-100"
        [buttonClass]="'btn w-100 h-100 ' + buttonClass"
        [loading]="isLoading"
      >
      </py-action-button>
    </ng-template>
  </form>
</div>
